import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './UnorderedItem.module.scss'

/** @type {import("./types.d").default} */
const UnorderedItem = ({ children, variant = 'default', className }) => (
  <li className={clsx('UnorderedItem', classes.root, classes[variant], className)} data-testid="unordered-list-item">
    <div className={classes.iconContainer}>
      <Icon icon="circle" className={classes.icon} />
    </div>
    {children}
  </li>
)

export default UnorderedItem
